import classNames from "classnames";
import React from "react";

const FilterButton = ({ onClick, isActive, children }) => {
  return (
    <button
      className={classNames(
        "p-2 py-1 rounded-[23px] font-light min-w-[50px] hover:bg-primary hover:text-white border border-primary",
        { "bg-primary text-white": isActive }
      )}
      onClick={onClick}
    >
      {children}
    </button>
  );
};

export default React.memo(FilterButton);
